<template>
  <div class="w-600">
    <div class="p-l-50 p-t-30 p-b-30">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">基础参数</div>
          <div>
            <el-form-item label="系统名称" prop="SYSTEM_NAME">
              <el-input v-model.trim="form.SYSTEM_NAME" class="h-40 w-200"></el-input>
            </el-form-item>
            <el-form-item label="LOGO">
              <el-upload
                class="avatar-uploader"
                drag
                :action="uploadUrl"
                :thumbnail-mode="true"
                :on-preview="viewPic"
                :on-remove="handleRemove"
                :on-success="uploadSuccess"
                :on-error="uploadFail"
                :file-list="fileList">
                <img v-if="form.SYSTEM_LOGO" :src="imgUrl + form.SYSTEM_LOGO" style="width:100%;max-height:300px">
                <i v-else class="el-icon-upload"></i>
                <!-- <i class="el-icon-upload"></i> -->
                <div class="el-upload__tip" slot="tip">将文件拖到此处，或<em>点击上传</em>，只能上传jpg/png文件</div>
              </el-upload>
              <el-button @click="clearLogo" v-show="form.SYSTEM_LOGO">清除图片</el-button>
            </el-form-item>
            <el-form-item label="是否开启记录日志">
              <el-radio-group v-model="form.IS_LOG">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="登录会话有效期" prop="LOGIN_SESSION_VALID">
              <el-input v-model="form.LOGIN_SESSION_VALID" class="h-40 w-200"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">登录页配置</div>
          <div>
            <el-form-item label="登录框标题" prop="LOGIN_TITLE">
              <el-input class="h-40 w-300" v-model.trim="form.LOGIN_TITLE"></el-input>
            </el-form-item> 
            <el-form-item label="登录验证码">
              <el-radio-group v-model="form.IDENTIFYING_CODE">
                <el-radio label="1">打开</el-radio>
                <el-radio label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="版权信息" prop="COPYRIGHT">
              <el-input type="textarea" class="h-40 w-300" v-model.trim="form.COPYRIGHT"></el-input>
            </el-form-item>
            <el-form-item label="界面底色" prop="LOGIN_BG_COLOR">
              <el-select class="h-40 w-300" v-model="form.LOGIN_BG_COLOR">
                <el-option
                  v-for="option in bgColors"
                  :label="option.name"
                  :value="option.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="界面背景图（可选）">
              <el-upload
                class="avatar-uploader"
                drag
                :action="uploadUrl"
                :thumbnail-mode="true"
                :on-preview="viewPic"
                :on-remove="handleRemove"
                :on-success="uploadBgImgSuccess"
                :on-error="uploadFail"
                :file-list="bgImgList">
                <img v-if="form.LOGIN_BG_IMG" :src="imgUrl + form.LOGIN_BG_IMG" style="width:100%;max-height:300px">
                <i v-else class="el-icon-upload"></i>
                <!-- <i class="el-icon-upload"></i> -->
                <div class="el-upload__tip" slot="tip">将文件拖到此处，或<em>点击上传</em>，只能上传jpg/png文件</div>
              </el-upload>
              <el-button @click="clearBgImg" v-show="form.LOGIN_BG_IMG">清除图片</el-button>
            </el-form-item>
            <el-form-item label="界面动画组件">
              <el-select class="h-40 w-300" v-model="form.ANIMATION_FRAME">
                <el-option
                  v-for="option in animationOptions"
                  :label="option.name"
                  :value="option.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <div class="m-b-10 p-20 bor-ccc pos-rel">
          <div class="tit">企业微信</div>
          <div>
            <el-form-item label="企业微信">
              <el-radio-group v-model="form.USE_WECHAT_WORK">
                <el-radio label="1">打开</el-radio>
                <el-radio label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="form.USE_WECHAT_WORK == 1">
              <el-form-item label="默认密码" prop="DEFAUTL_PASSWD">
                <el-input class="h-40 w-200" v-model.trim="form.DEFAUTL_PASSWD"></el-input>
              </el-form-item>
              <el-form-item label="微信消息跳转路径">
                <el-input class="h-40 w-200" v-model.trim="form.WECHAT_MSG_URL"></el-input>
              </el-form-item>
              <el-form-item label="Corpid" prop="APP_ID">
                <el-input class="h-40 w-200" v-model.trim="form.APP_ID"></el-input>
              </el-form-item>
              <!-- <el-form-item label="Secret" prop="APP_SECRET">
                <el-input class="h-40" v-model.trim="form.APP_SECRET"></el-input>
              </el-form-item> -->
              <div class="agentsTab">
                <el-table
                    :data="form.agents"
                    border
                    class="m-b-10 w-650">
                  <el-table-column
                    prop="name"
                    label="应用名称">
                    <template scope="scope">
                      <el-input placeholder="应用名称" v-model="scope.row.name"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="agent_id"
                          label="应用ID">
                    <template scope="scope">
                      <el-input placeholder="应用名称" v-model="scope.row.agent_id"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          prop="secret"
                          label="秘钥">
                    <template scope="scope">
                      <el-input placeholder="秘钥" class="w-120" v-model="scope.row.secret"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                          label="操作">
                    <template scope="scope">
                      <div>
                        <el-button size="small" @click="delAgent(scope.$index)">删除</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button type="success" class="m-b-10" @click="addApplication">添加新应用</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="m-t-20">
      <el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
      <el-button @click="goback()">返回</el-button>
    </div>
    <preview ref="preview" :url="propsImg"></preview>
  </div>
</template>

<style scope>
  .avatar-uploader .el-upload {
    border: 1px dashed #aaa;
    border-radius: 6px;
    cursor: pointer;
  }
</style>

<script>
  import http from '../../../../assets/js/http'
  import _verify from '../../../../assets/js/verify'
  import preview from './preview.vue'

  export default {
    data() {
      return {
        isLoading: false,
        fileList: [],
        bgImgList: [],
        showAddAgent: false,
        propsImg: '',
        form: {
          SYSTEM_NAME: '',
          IDENTIFYING_CODE: '0',
          LOGIN_SESSION_VALID: '0',
          USE_WECHAT_WORK: '1',
          SYSTEM_LOGO: '',
          APP_ID: '',
          APP_SECRET: '',
          DEFAUTL_PASSWD: '',
          ANIMATION_FRAME: '',  // 动画组件
          LOGIN_BG_COLOR: '',
          LOGIN_BG_IMG: '',
          LOGIN_TITLE: '',
          WECHAT_MSG_URL: '',
          agents: [],
          IS_LOG: '0',
          COPYRIGHT: ''
        },
        uploadUrl: '',
        imgUrl: '',
        rules: {
          SYSTEM_NAME: [
            { required: true, message: '请输入系统名称' }
          ],
          LOGIN_SESSION_VALID: [
            { required: true, message: '请输入登录有效期' },
            { validator: this.isNumber, message: '请输入数字', trigger: 'blur' }
          ],
          APP_ID: [
            { required: true, message: '请输入Corpid' }
          ],
          APP_SECRET: [
            { required: true, message: '请输入Secret' }
          ],
          DEFAUTL_PASSWD: [
            { required: true, message: '请输入默认密码' }
          ],
          name: [
            { required: true, message: '请输入应用名称' }
          ],
          agent_id: [
            { required: true, message: '请输入应用ID' }
          ],
          secret: [
            { required: true, message: '请输入秘钥' }
          ],
          COPYRIGHT: [
            { required: true, message: '版权信息' }
          ],
          LOGIN_TITLE: [
            { required: true, message: '请输入登录框标题' }
          ]
        },
        bgColors: [
          { id: '#f3f3f2', name: '灰色' },
          { id: '#ffffff', name: '白色' },
          { id: '#000000', name: '黑色' }
        ],
        animationOptions: [
          { id: 'null', name: '无' },
          { id: 'desk', name: '办公桌' }
        ]
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            let flag = false
            if (this.form.agents && this.form.agents.length > 0) {
              _(this.form.agents).forEach((res) => {
                if (res.name == '' || res.agent_id == '' || res.secret == '') {
                  if (res.agent_id != 0) {
                    _g.toastMsg(this, 'error', '应用信息必须全部填写')
                    flag = false
                    return false
                  } else {
                    flag = true
                  }
                } else {
                  flag = true
                }
              })
            } else {
              flag = true
            }
            if (flag) {
              this.isLoading = !this.isLoading
              this.apiPost('admin/systemConfigs', this.form).then((res) => {
                if (res.code == 200) {
                  _g.toastMsg(this, 'success', '提交成功')
                  setTimeout(() => {
                    this.goback()
                  }, 1500)
                } else {
                  this.isLoading = !this.isLoading
                  _g.dealError(this, res)
                }
              })
            }
          }
        })
      },
      isNumber(rules, value, callback) {
        if (!_verify.isNumber(value)) {
          callback(new Error('请输入数字'))
        } else {
          callback()
        }
      },
      uploadSuccess(res, file, fileList) {
        // console.log('res = ',_g.j2s(res))
        this.form.SYSTEM_LOGO = res.data
        // let data = {
        //   name: '图片',
        //   url: window.imgUrl + res.data
        // }
        // if (this.fileList.length) {
        //   this.fileList[0] = data
        // } else {
        //   this.fileList.push(data)
        // }
        this.fileList = []
      },
      uploadBgImgSuccess(res, file, fileList) {
        this.form.LOGIN_BG_IMG = res.data
        this.bgImgList = []
      },
      uploadFail(err, res, file) {
        console.log('err = ', _g.j2s(err))
        console.log('res = ', _g.j2s(res))
      },
      handleRemove(file, fileList) {
        console.log('file = ', file)
        console.log('fileList = ', fileList)
      },
      clearLogo() {
        this.form.SYSTEM_LOGO = ''
      },
      clearBgImg() {
        this.form.LOGIN_BG_IMG = ''
      },
      viewPic() {
        this.propsImg = this.fileList[0].url
        this.$refs.preview.open()
      },
      goback() {
        router.go(-1)
      },
      addApplication() {
        this.form.agents.push(
          {
            agent_id: '',
            secret: '',
            name: ''
          }
        )
      },
      addAgents() {
        if (this.agentsArray.agent_id == '' || this.agentsArray.name == '' || this.agentsArray.secret == '') {
          _g.toastMsg(this, 'error', '新增应用信息不完整')
        } else {
          let flag = false
          _(this.form.agents).forEach((res) => {
            if (res.agent_id == this.agentsArray.agent_id) {
              flag = true
            }
          })
          if (!flag) {
            this.form.agents.push(this.agentsArray)
            this.agentsArray = {
              agent_id: '',
              name: '',
              secret: ''
            }
            this.showAddAgent = false
          } else {
            _g.toastMsg(this, 'error', '应用ID不能重复')
          }
        }
      },
      delAgent(index) {
        this.$confirm('确认要删除该应用?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.agents.splice(index, 1)
          console.log(this.form.agents)
          _g.toastMsg(this, 'success', '成功删除该应用,提交生效')
        })
      }
    },
    created() {
      this.uploadUrl = window.HOST + 'admin/Upload'
      this.imgUrl = window.imgUrl
      this.apiGet('admin/systemConfigs').then((res) => {
        if (res.code == 200) {
          this.form.SYSTEM_NAME = res.data.SYSTEM_NAME
          this.form.IDENTIFYING_CODE = res.data.IDENTIFYING_CODE
          this.form.LOGIN_SESSION_VALID = res.data.LOGIN_SESSION_VALID
          this.form.USE_WECHAT_WORK = res.data.USE_WECHAT_WORK
          this.form.APP_ID = res.data.APP_ID
          this.form.APP_SECRET = res.data.APP_SECRET
          this.form.DEFAUTL_PASSWD = res.data.DEFAUTL_PASSWD
          this.form.agents = res.data.agents
          this.form.IS_LOG = res.data.IS_LOG
          this.form.COPYRIGHT = res.data.COPYRIGHT
          this.form.ANIMATION_FRAME = res.data.ANIMATION_FRAME
          this.form.LOGIN_BG_COLOR = res.data.LOGIN_BG_COLOR
          this.form.LOGIN_BG_IMG = res.data.LOGIN_BG_IMG
          this.form.LOGIN_TITLE = res.data.LOGIN_TITLE
          this.form.WECHAT_MSG_URL = res.data.WECHAT_MSG_URL
          console.log('企业号自建应用消息', this.form.agents)
          if (res.data.SYSTEM_LOGO) {
            // let img = window.imgUrl + res.data.SYSTEM_LOGO
            // this.fileList.push({ name: '图片', url: img })
            this.form.SYSTEM_LOGO = res.data.SYSTEM_LOGO
          }
        } else {
          _g.dealError(this, res)
        }
      })
    },
    components: {
      preview
    },
    mixins: [http]
  }
</script>
<style scoped>
  .agentsTab{
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// add.vue?13917cd4